import React, { Component } from 'react';
import {
  Container,
} from 'reactstrap';
import AdminContainer from '../components/Admin/AdminContainer';

class Users extends Component {

  componentDidMount = () => {
    this.props.log('Users.js/componentDidMount');
  }

  render() {
    return (<Container fluid={true}>
      <AdminContainer
        {...this.props}
        showUsers={true}
        showRoles={true}
        showPermissions={true}
        showClients={false}
      />
    </Container>
    );
  }
}

export default Users;
